import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { AsyncActionStatus } from '../../../actions/common.actionTypes';
import { dashboardSection, routes } from '../../../constants';
import { selectPinnedContents, selectPinnedStatus } from '../../../reducers/pinned.selectors';
import { MAX_ITEMS, MIN_ITEMS } from '../../../routes/DashboardPage/hooks/useDashboardRowFetch';
import useRouter from '../../../utils/useRouter';
import DashboardMuiCard from '../../cards/MuiCard/DashboardMuiCard';
import { getCommonCardProps } from '../../Search/SearchResults/SearchResults';
import DashboardRowShell from '../DashboardRowShell/DashboardRowShell';

/**
 * The user's pinned materials on the new dashboard (PRO-40). Read-only over the
 * pinned slice — `AppPage` already fetches pinned contents globally. Hidden on a
 * fetch error or when fewer than MIN_ITEMS pinned items resolve.
 */
const PinnedRow: React.FC = () => {
	const { t } = useTranslation();
	const { router } = useRouter();

	const items = useSelector(selectPinnedContents);
	const status = useSelector(selectPinnedStatus);

	const isLoading = status === AsyncActionStatus.INITIAL || status === AsyncActionStatus.LOADING;
	const hidden = status === AsyncActionStatus.ERROR || (!isLoading && items.length < MIN_ITEMS);

	return (
		<DashboardRowShell
			title={t('My pinned items')}
			onShowAll={() => router.push(`/${routes.pinned.root}`)}
			loading={isLoading}
			hidden={hidden}
		>
			{items.slice(0, MAX_ITEMS).map((item) => (
				<DashboardMuiCard
					key={item.id}
					contentType={item.type === 'product' ? 'product' : item.fileType}
					{...getCommonCardProps(item)}
					dashboardSection={dashboardSection.favorites}
				/>
			))}
		</DashboardRowShell>
	);
};

export default PinnedRow;
